import { createResource } from 'react-resource-router';

import {
  setCurrentPipeline,
  clearCurrentPipeline,
} from 'src/components/pipelines/redux/actions/pipelines';
import { getPipelineUrl } from 'src/components/pipelines/redux/sagas/pipelines';
import { ResourceContext } from 'src/router/types';

import { fetchData, hasFetchedPipeline, isOnboardingPage } from './utils';

export type Params = {
  pipelineUuid: string;
  stepUuid: string;
  repositoryFullSlug: string;
  trigger: string;
};

export const getUrl = (params: Params): string => {
  return getPipelineUrl(params.repositoryFullSlug, params.pipelineUuid);
};

export const loadCurrentPipelineResource = createResource({
  type: 'currentPipeline',
  getKey: ({ match: { params } }) => getUrl(params as Params),
  maxAge: 0,
  getData: async ({ match: { params } }, { reduxStore }: ResourceContext) => {
    const { dispatch, getState } = reduxStore;

    if (
      hasFetchedPipeline(getState()) ||
      isOnboardingPage(params.pipelineUuid)
    ) {
      return { status: 'success' };
    }

    dispatch(clearCurrentPipeline());
    const data = await fetchData(
      getUrl(params as Params),
      'current_pipeline_resource_exception'
    );
    dispatch(setCurrentPipeline(data));
    return { status: 'success' };
  },
});
